import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=d5d95ece&scoped=true&"
import script from "./ProjectStatus.vue?vue&type=script&lang=js&"
export * from "./ProjectStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatus.vue?vue&type=style&index=0&id=d5d95ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d95ece",
  null
  
)

export default component.exports